<template>
  <v-app-bar :style="{ backgroundColor: dynamic }" elevate-on-scroll class="headroom header">
    <v-toolbar-title @click="navigateTo({name: 'home'})" class="header-title cursor-pointer">
      ER
      <span class="hidden-sm-and-down">| Edgardo Reinoso</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="showItems">
      <v-btn
        v-for="(item, index) in buttons"
        :key="index"
        :ripple="false"
        class="hidden-sm-and-down"
        text
      >
        <a
          id="nav-btn"
          :href="item.link"
          v-smooth-scroll="{duration: 1000, offset: -80}"
        >{{ item.name }}</a>
      </v-btn>
      <v-btn :ripple="false" class="hidden-sm-and-down" text>
        <a
          id="nav-btn"
          href="https://personal-website-assets104410-dev.s3.us-east-1.amazonaws.com/others/edgardo_reinoso_cv.pdf"
          target="_blank"
        >Resume</a>
      </v-btn>
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="hidden-md-and-up" icon v-on="on">
            <v-icon class="white--text">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in buttons" :key="index" class="cursor-pointer v-items">
            <v-list-item-title>
              <a
                style="text-decoration:none;outline:none;color:black"
                :href="item.link"
                v-smooth-scroll="{duration: 1000, offset: -80}"
              >{{ item.name }}</a>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <a
                style="text-decoration:none;outline:none;color:black"
                href="https://personal-website-assets104410-dev.s3.us-east-1.amazonaws.com/others/edgardo_reinoso_cv.pdf"
                target="_blank"
              >Resume</a>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      limitPosition: 1,
      lastPosition: 0,
      navItemColor: "white",
      dynamic: "transparent",
      scrolled: false,
      showItems: false,
      buttons: [
        {
          link: "#projects",
          name: "Projects"
        },
        {
          link: "#blogs",
          name: "Blogs"
        },
        {
          link: "#experience",
          name: "Experience"
        },
        {
          link: "#certifications",
          name: "Certifications"
        }
      ]
    };
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    navItemsColor() {
      if (this.$props.parameter === "Home") {
        this.dynamic = "transparent";
        this.showItems = true;
      } else {
        this.dynamic = "rgba(38, 38, 38, 0.77)";
      }
    },
    handleScroll() {
      if (
        this.lastPosition < window.scrollY &&
        this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
        this.dynamic = "rgba(38, 38, 38, 0.77)";
      }

      if (this.lastPosition == window.scrollY) {
        this.scrolled = false;
        this.dynamic = "transparent";
      }
    }
  },
  created() {
    if (this.$props.parameter === "Home") {
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  destroyed() {
    if (this.$props.parameter === "Home") {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
  mounted() {
    // gives the initial font color to the items
    this.navItemsColor();
    // console.log("value for parameter header: ", this.$props.parameter);
  },
  props: {
    parameter: String
  }
};
</script>

<style>
.header {
  position: fixed;
  z-index: 1;
}
.headroom {
  transition: all 0.3s ease-in-out;
}
.header-title {
  color: white;
  font-weight: 500;
}
.cursor-pointer:hover {
  cursor: pointer;
}
.v-items:hover {
  background: #eee;
}
#nav-btn {
  color: white;
  text-decoration: none;
}
#nav-btn:hover {
  color: #f5f6f4;
  /* color: green; */
}

#nav-btn:active {
  color: #f5f6f4;
}
</style>